import { render, staticRenderFns } from "./FaceRecognition.vue?vue&type=template&id=3532ca08&scoped=true&"
import script from "./FaceRecognition.vue?vue&type=script&lang=js&"
export * from "./FaceRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3532ca08",
  null
  
)

export default component.exports